<template>
    <!-- ========== HEADER ========== -->
    <header id="header" class="header hheader-sticky-top-lg">
        <div class="header-section">
          <div id="logoAndNav" class="container">
                <!-- Nav -->
                <nav class="navbar navbar-expand-lg">
                    <!-- Logo -->
                    <div class="">
                      <router-link
                          to="/"
                          v-slot="{ href, route, navigate }">
                        <a class="navbar-brand" href="#" aria-label="Cheap Mortgage Club">
                          <img src="/assets/cmc/brand/cmc-logo-colour-no_background.png" :href="href" @click="navigate" alt="Cheap Mortgage Club">
                        </a>
                      </router-link>
                    </div>
                    <!-- End Logo -->

                    <!-- Responsive Toggle Button -->
                    <button type="button" class="navbar-toggler btn btn-icon btn-sm rounded-circle"
                            aria-label="Toggle navigation"
                            aria-expanded="false"
                            aria-controls="navBar"
                            data-toggle="collapse"
                            data-target="#navBar">
                      <span class="navbar-toggler-default">
                        <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                          <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"/>
                        </svg>
                      </span>
                      <span class="navbar-toggler-toggled">
                        <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                            <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"/>
                        </svg>
                      </span>
                    </button>
                    <!-- End Responsive Toggle Button -->

                    <!-- Navigation -->
                    <div id="navBar" class="collapse navbar-collapse">
                        <ul class="navbar-nav hheader-sticky-top-inner">
                            <!-- Blog -->
                            <router-link
                                to="/mortgage-watch/getting-started"
                                v-slot="{ href, route, navigate }">
                              <li class="navbar-nav-item">
                                <a class="nav-link" :href="href" @click="navigate">MortgageWatch<sup style="right: 0;">TM</sup></a>
                              </li>
                            </router-link>
                            <router-link
                                to="/news"
                                v-slot="{ href, route, navigate }">
                              <li class="navbar-nav-item">
                                <a class="nav-link" :href="href" @click="navigate">News</a>
                              </li>
                            </router-link>
<!--                            <router-link-->
<!--                                    to="/lenders"-->
<!--                                    v-slot="{ href, route, navigate }">-->
<!--                                <li class="navbar-nav-item">-->
<!--                                    <a class="nav-link" :href="href" @click="navigate">Lenders</a>-->
<!--                                </li>-->
<!--                            </router-link>-->
<!--                            <router-link-->
<!--                                    to="/products"-->
<!--                                    v-slot="{ href, route, navigate }">-->
<!--                                <li class="navbar-nav-item">-->
<!--                                    <a class="nav-link" :href="href" @click="navigate">Products</a>-->
<!--                                </li>-->
<!--                            </router-link>-->
                            <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Mortages
                              </a>
                              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
<!--                                <h6  >Most Popular</h6>-->
                                <router-link
                                    to="/products/remortgage"
                                    v-slot="{ href, route, navigate }">
                                  <a class="dropdown-item" :href="href" @click="navigate">Remortgage</a>
                                </router-link>
<!--                                <router-link-->
<!--                                    to="/products/first-time-buyer"-->
<!--                                    v-slot="{ href, route, navigate }">-->
<!--                                  <a class="dropdown-item" :href="href" @click="navigate">First Time Buyer</a>-->
<!--                                </router-link>-->
<!--                                <router-link-->
<!--                                    to="/products/moving-house"-->
<!--                                    v-slot="{ href, route, navigate }">-->
<!--                                  <a class="dropdown-item" :href="href" @click="navigate">Moving House</a>-->
<!--                                </router-link>-->
                                <a class="dropdown-item disabled">First Time Buyer <span class="badge badge-soft-primary">Coming soon</span></a>
                                <a class="dropdown-item disabled">Moving House <span class="badge badge-soft-primary">Coming soon</span></a>
                                <a class="dropdown-item disabled">Buy-to-Let <span class="badge badge-soft-primary">Coming soon</span></a>
<!--                                <div class="dropdown-divider"></div>-->
<!--                                <router-link-->
<!--                                    to="/products"-->
<!--                                    v-slot="{ href, route, navigate }">-->
<!--                                  <a class="dropdown-item" :href="href" @click="navigate">All mortgages</a>-->
<!--                                </router-link>-->
                              </div>
                            </li>
                            <li class="navbar-nav-item">
                              <button class="btn btn-xs btn-icon btn-ghost-secondary" @click="showBasket = !showBasket">
                                <i class="fas fa-shopping-cart fa-lg"></i>
                                <span v-if="shoppingBasket.length > 0" class="btn-status btn-primary">
                                  <span class="btn-status-initials">{{ shoppingBasket.length }}</span>
                                </span>
                              </button>                              
                            </li>
                            <!-- Button -->
                            <li class="navbar-nav-last-item">
                              <div v-if="!$auth.loading">
                                <button v-if="!$auth.isAuthenticated" 
                                   class="btn btn-sm btn-secondary" 
                                   @click="login()">
                                  Login <i class="fas fa-user-circle ml-1"></i>
                                </button>
                                <router-link
                                    v-if="$auth.isAuthenticated"
                                    to="/my/dashboard"
                                    v-slot="{ href, route, navigate }">
                                  <button class="btn btn-sm btn-success" :href="href" @click="navigate">
                                    My Account <i class="fas fa-user-circle ml-1"></i>
                                  </button>
                                </router-link>
                              </div>
                            </li>
                            <!-- End Button -->
                        </ul>
                    </div>
                    <!-- End Navigation -->
                </nav>
                <!-- End Nav -->
            </div>
          <transition name="slide">
            <ShoppingBasket 
              v-if="showBasket"
              @view-product="viewProduct($event)"
              @remove-product="removeFromShoppingBasket($event)"
              @close-basket="showBasket = false"></ShoppingBasket>
          </transition>
        </div>
    </header>
  <!-- ========== END HEADER ========== -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ShoppingBasket from "@/components/ShoppingBasket";
  
  export default {
    name: "LayoutHeader",
    
    components: {
      ShoppingBasket
    },

    data() {
      return {
        showBasket: false,
        showModal: false
      }
    },
    
    methods: {
      ...mapActions([
        "removeProductFromBasket"
      ]),

      viewProduct(item) {
        this.$emit("preview-product", item);
      },
      
      removeFromShoppingBasket(item) {
        this.removeProductFromBasket(item);
        if (this.shoppingBasket.length === 0) {
          this.showBasket = false;
        }
      },
      login() {
        this.$auth.loginWithRedirect();
      },
      logout() {
        this.$auth.logout({
          returnTo: window.location.origin
        });
      }
    },
    
    computed: {
      ...mapGetters([
        "shoppingBasket", "isLoggedIn"
      ])
    }
  }
</script>

<style>
img.greyscale {
  filter: grayscale(75%);
}

img.greyscale:hover {
  filter: none;
}
</style>

<style scoped>
</style>
